<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['PM']['MP']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('PM.AGI')"
                                                  v-model="arr_FV['AGI']"
                                                  @input="AgentGroupChange" />
                                <span class="ErrMsg">{{ ValidationPromotionErrMsg('AGI','AGI') }}</span>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="ddSubAgentList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGI']"
                                            openDirection="below" />
                                <span class="ErrMsg"></span>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :cacheOptions="false"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="arr_FV['MB']" />
                                <span class="ErrMsg">{{ ValidationPromotionErrMsg('MB', 'MCI') }}</span>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["C"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :disabled="!bool_currencyloaded"
                                            :placeholder="this.utilGetDDLanguage('PM.C')"
                                            v-model="arr_FV['CI']" />
                                <span class="ErrMsg">{{ ValidationPromotionErrMsg('CI', 'MCI') }}</span>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>

        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['PM']['MPL']}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>
                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage['MEM']['U']}} <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['CI']}} <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i></th>
                                <th><span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> / <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span></th>
                                <th>{{this.getLanguage['PM']['LDI']}} <i @click="setSortTable('LDA')" :class="setSortLogo('LDA')" class="sortlogo"></i></th>
                                <th v-if="checkModuleAccess2(constAccessType.add)">{{this.getLanguage['PM']['MP']}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper manual-promotion-body" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage['MEM']['U']}} <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['CI']}} <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i></th>
                                <th><span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> / <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span></th>
                                <th>{{this.getLanguage['PM']['LDI']}} <i @click="setSortTable('LDA')" :class="setSortLogo('LDA')" class="sortlogo"></i></th>
                                <th v-if="checkModuleAccess2(constAccessType.add)">{{this.getLanguage['PM']['MP']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="arr_Member.length == 0">
                                <td colspan="6">{{this.getLanguage['GL']['NR']}}</td>
                            </tr>
                            <tr v-else-if="checkModuleAccess2(constAccessType.add)">
                                <td colspan="5"></td>
                                <td class="mwidth200">
                                    <treeselect :multiple="false"
                                                :options="dd_promotion"
                                                :auto-load-root-options="false"
                                                :placeholder="getLanguage['PM']['PCD']"
                                                class="inline inline-promo350"
                                                v-model="int_PIAll" />
                                    <CButton :disabled="sensBtn" size="sm" type="submit" color="info" @click="updateAllPromotion()" class="inline">
                                        <span style="margin-right: 5px;">{{ getLanguage['BTN']['SA']}}</span>
                                    </CButton>
                                    <CButton :disabled="sensBtn" size="sm" color="primary" @click="popUpNotif(-1)" class="inline">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['MPAA']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NMPAA']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="bool_sendAllLoading"></div>
                                    </CButton>
                                    <span class="ErrMsg">{{ str_PIAll_err }}</span>
                                </td>
                            </tr>
                            <tr v-for="(data,index) in arr_Member" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': ''">
                                <td>{{ CountItem(index+1) }}</td>
                                <td v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class='kema-eft' @click="CheckingMember(data.AGI,data.MI)">
                                    <span class="grid-line">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </td>
                                <td v-else-if="(isSENS == 1 && data.AGI != curAGI)" class='kema-eft'>
                                    <span class="grid-line">

                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)">{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </td>
                                <td>{{ data.CISOC }}</td>
                                <td>
                                    <span style="text-align:center;display:block">
                                        <span v-if="getUserInfo.AT!=4">
                                            <span v-if="data.TSI > 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                            </span>
                                            <span v-else-if="data.TSI > 0 && (isSENS == 1 && data.AGI != curAGI)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                            </span>
                                            <span class="grid-line" v-else>-</span>
                                        </span>
                                        <span v-else-if="getUserInfo.AT==4">
                                            <span v-if="data.SUBATSI > 0" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.SUBATSI }})</span> / <span style="color:red">({{ data.SUBATM }})</span>
                                            </span>
                                            <span class="grid-line" v-else>-</span>
                                        </span>
                                        <span class="grid-line" v-else>-</span>
                                        <table class='p-4 mt-2' v-if="opened.includes(data.I)" style="width: 100%; background: #ebedef">
                                            <thead>
                                                <tr>
                                                    <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                    <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(row,index1) in arry_systemId[data.I]">
                                                    <tr style="text-align: left;">
                                                        <td :style="[row.MI>0?{'cursor':'pointer'}:{}]" @click="row.MI>0?toggleFingPrintId(row,index,index1):{}" :class="{opened: opened.includes(index+'_'+index1)}">{{ row.SI }} <span style="color:red" v-if="row.MI>0">({{row.MI}})</span></td>
                                                        <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    </tr>
                                                    <tr v-if="opened.includes(index+'_'+index1)" style="background: darkred">
                                                        <td colspan="2" style="padding:2px">
                                                            <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item,index) in arry_visitorMembers[index+'_'+index1]" style="text-align:left">
                                                                        <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                        <td>
                                                                            <router-link :to="{ path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}}" target="_blank">{{ item.UB }}</router-link>
                                                                        </td>
                                                                        <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </span>
                                </td>
                                <td v-if="data.LDA > 0">{{formatDate(data.LDTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}<br />{{ formatNumber(data.LDA, 2, data.CS) }}</td>
                                <td v-else></td>
                                <td v-if="checkModuleAccess2(constAccessType.add)">
                                    <treeselect :multiple="false"
                                                :options="dd_promotion"
                                                :auto-load-root-options="false"
                                                :placeholder="getLanguage['PM']['PCD']"
                                                class="inline inline-promo350"
                                                v-model="data.PI" />
                                    <CButton :disabled="sensBtn" size="sm" type="submit" color="primary" @click="popUpNotif(index)" class="inline">
                                        <span style="margin-right: 5px;">
                                            <span v-if="checkPermissionAccess2(constAccessType.edit)">{{ getLanguage['PM']['MPA']}}</span>
                                            <span v-else>{{ getLanguage['PM']['NMPA']}}</span>
                                        </span>
                                        <div class="spinner-border spinner-border-sm" v-if="data.bool_sendLoading"></div>
                                    </CButton>
                                    <span class="ErrMsg">{{ data.str_PI_err }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
        },

        data() {
            return {
                bool_fingerPrintLoading: [], // fingerprint/lastSystemID
                opened: [],
                arry_visitorMembers: [],
                arry_systemId: [],
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                int_PIAll: null,
                bool_sendAllLoading: false,
                bool_showSearchBar: true,
                bool_isNotifM: false,
                sensBtn: true,
                str_PIAll_err: "",
                arr_FV: {
                    "AGI": null,
                    "SAGI": null,
                    "DR": {
                        startDate: this.getTodayDate(),
                        endDate: this.getTodayEndDate()
                    },
                    "MB": null,
                    "CI": null
                },
                obj_PI: {
                    "ATAGI": "",
                    "CI": 0,
                    "PI": null,
                    "CNT": "",
                    "CNM": "",
                    "IDX": null,
                    //"CT": 1,
                    "R": [],
                },
                arr_Member: [],
                dd_currency: [],
                dd_game: [],
                dd_gameprovider: [],
                dd_gamecategory: [],
                dd_agentgroup: [],
                constAccessType: constAccessType,
                ddMemberList: [],
                dd_promotion: [],
                bool_PromotionCV: false,
                ddSubAgentList: null,
                ddDefaultSubBrand: null,
                rtSubBrand: 0,
                bool_currencyloaded: false,
            }
        },
        validations: {
            arr_FV: {
                AGI: {
                    required: requiredIf(function (vm) {
                        return vm.SAGI == null || vm.SAGI == "";
                    })
                },
                CI: {
                    required: requiredIf(function (vm) {
                        return vm.MB == null || vm.MB == "";
                    })
                },
                MB: {
                    required: requiredIf(function (vm) {
                        return vm.CI == null || vm.CI == 0;
                    })
                },
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess']),
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            checkPermissionAccess2(type) {
                return this.checkModuleAccess('AMP', 'P', type);
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('MP', 'P', type);
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getPromotionMemberList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getPromotionMemberList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getPromotionMemberList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;

                //this.getDataApi(`/api/dd/cur/0`,
                //    function (d, s) {
                //        if (s) {
                //            that.dd_currency = d.dropdownlist;
                //        }
                //    });

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }

                        }
                    });

                this.getDataApi(`/api/dd/gameCat`,
                    function (d, s) {
                        if (s) {
                            that.dd_gamecategory = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/gameProv`,
                    function (d, s) {
                        if (s) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                            }
                            that.dd_gameprovider = d.dropdownlist;
                        }
                    });

                this.GetGameDropDownList();
            },
            disableAgentGroupParent(item) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },

            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            GetGameDropDownList() {
                var gameCategoryId = this.arr_FV["GCI"] == null ? 0 : this.arr_FV["GCI"];
                var gameProviderId = this.arr_FV["GPI"] == null ? 0 : this.arr_FV["GPI"];
                var that = this;

                this.getDataApi(`/api/dd/game/0/${gameCategoryId}/${gameProviderId}`,
                    function (d, s) {
                        if (s) {
                            that.dd_game = d.dropdownlist;

                            for (var idx = 0; idx < that.dd_game.length; idx++) {
                                that.dd_game[idx].label = that.changeGameName(that.dd_game[idx].extra, that.dd_game[idx].label);
                            }
                        }
                    });
            },
            changeGameName(provider, item) {
                if (provider in this.getLanguage && item in this.getLanguage[provider])
                    item = this.getLanguage[provider][item];

                return item;
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = 0;
                    if (this.arr_FV["AGI"]) {
                        agi = this.arr_FV["AGI"].split("-")[1];
                    }
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.arr_FV["AGI"]) {
                    var agentList = this.arr_FV["AGI"].split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT == 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.arr_FV['SAGI'] = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getDropdownList();
                    });
            },
            ValidationPromotionErrMsg(value, langKey = "") {
                if (this.bool_PromotionCV) {
                    if (langKey == "") {
                        langKey = value;
                    }

                    let validateObj = this.$v.arr_FV[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["PM"][langKey]);
                    }
                }
            },
            getPromotionMemberList() {
                this.bool_PromotionCV = true;
                this.$v.arr_FV.$touch();

                if (!this.$v.arr_FV.$error) {
                    this.bool_fullLoading = true;
                    var that = this;
                    var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                    if (this.arr_FV) {

                        if (path) {
                            path += "&";
                        }

                        path += (
                            "f.ATAGI=" + (this.arr_FV["SAGI"] != null ? "4-" + this.arr_FV["SAGI"] : (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"])) +
                            "&f.MI=" + (this.arr_FV["MB"] == null ? "" : this.arr_FV["MB"]) +
                            "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"])
                        );

                        this.obj_PI.ATAGI = this.arr_FV["SAGI"] != null ? this.arr_FV["SAGI"] : (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]);
                        this.obj_PI.CI = this.arr_FV["CI"] == null ? 0 : this.arr_FV["CI"];

                    }

                    this.getDataApi(`/api/mpromo/lmp?${path}`,
                        function (d, s) {
                            that.bool_PromotionCV = false;

                            if (s) {
                                that.int_TP = Math.max(d.D.TotalPages, 1);
                                that.int_Total = d.D.TotalItems;
                                that.int_PIAll = null;

                                if (d.D.Items.length > 0) {
                                    let currencyId = d.D.Items[0].CI;
                                    let agi = d.D.Items[0].AGI;

                                    that.obj_PI["AGI"] = agi;

                                    that.getPromotionDDList(agi, currencyId, d.D.Items);
                                    that.resizeTableHead();
                                }
                                else {
                                    that.bool_fullLoading = false;
                                }
                            }
                        });
                }
            },
            getPromotionDDList(agi, currencyId, memberList) {
                var that = this;

                this.getDataApi(`/api/dd/promo/${agi}/1/${currencyId}/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_promotion = d.dropdownlist;
                        }
                        else {
                            that.dd_promotion = [];
                        }

                        that.bool_fullLoading = false;
                        that.arr_Member = memberList;
                        for (var i = 0; i < that.arr_Member.length; i++) {
                            that.arr_Member[i]['I'] = i + 1;
                            that.arr_Member[i]['bool_sendLoading'] = false;
                            that.arr_Member[i]['str_PI_err'] = "";
                            that.arr_Member[i]['PI'] = null;
                        }
                    });
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },

            updateAllPromotion() {
                if (this.int_PIAll >= 0) {
                    for (var i = 0; i < this.arr_Member.length; i++) {
                        this.arr_Member[i]['PI'] = this.int_PIAll;
                        this.arr_Member[i]['str_PI_err'] = "";
                    }

                    this.$forceUpdate();
                }
                else {
                    this.str_PIAll_err = String.format(this.getLanguage["ERR"]["1005"], this.getLanguage['PM']['CCP']);
                }
            },
            isNullOrWhitespace(input) {
                if (typeof input === 'undefined' || input == null) return true;
                return input.replace(/\s/g, '').length < 1;
            },
            TextValueChange(type, event) {
                if (type == "CNM") {
                    this.obj_PI.CNM = event.target.value;
                }
            },
            popUpNotif(index) {
                let isValid = false;

                if (index == -1) {
                    let selectedPI = 0;
                    for (let i = 0; i < this.arr_Member.length; i++) {
                        if (this.arr_Member[i]['PI'] > 0) {
                            selectedPI++;
                        }
                    }

                    if (selectedPI > 0) isValid = true;
                }
                else {
                    if (this.arr_Member[index]['PI'] > 0) isValid = true;
                }

                if (isValid) {
                    this.obj_PI["CNT"] = '';
                    this.obj_PI["CNM"] = '';
                    this.obj_PI["IDX"] = index;
                    this.submitPromotionMainSwitch()
                    //this.bool_isNotifM = true;
                    //this.int_tempStoreID = Id;
                }
            },
            submitPromotionMainSwitch() {
                //var Id = this.int_tempStoreID;
                if (this.isNullOrWhitespace(this.obj_PI["CNT"])) {
                    this.obj_PI["CNT"] = "::[PM][PST]::";    //this.getLanguage["PM"]["PST"];
                }
                if (this.isNullOrWhitespace(this.obj_PI["CNM"])) {
                    this.obj_PI["CNM"] = "::[PM][PSM]::";    //this.getLanguage["PM"]["PSM"];
                }

                if (this.obj_PI["IDX"] == -1) {
                    this.submitAllPromotion()
                } else {
                    this.submitPromotion(this.obj_PI["IDX"])
                }
            },
            submitAllPromotion() {
                this.bool_sendAllLoading = true;
                this.bool_fullLoading = true;

                this.obj_PI.R = [];

                for (let i = 0; i < this.arr_Member.length; i++) {
                    if (this.arr_Member[i].PI > 0) {
                        this.obj_PI.R.push({
                            "MI": this.arr_Member[i].MI,
                            "PI": this.arr_Member[i].PI
                        });
                    }
                }

                var that = this;

                this.postDataApi(`/api/mpromo/mapv2`, this.obj_PI,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            let index = 0;
                            let isAllValid = true;

                            for (var i = 0; i < that.arr_Member.length; i++) {
                                if (that.arr_Member[i].PI > 0) {
                                    if (d != null && d.D != null && d.D.Items != null && d.D.Items.length > 0 && !d.D.Items[index].S) {
                                        that.arr_Member[i]['str_PI_err'] = that.processMessage(d.D.Items[index].R);
                                        isAllValid = false;
                                    }
                                    else {
                                        that.arr_Member[i].PI = null;
                                        that.arr_Member[i]['str_PI_err'] = "";
                                    }

                                    index++;
                                }
                            }

                            that.bool_sendAllLoading = false;
                            //that.bool_isNotifM = false;
                            that.int_PIAll = null;

                            if (isAllValid) {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        }
                        else {
                            this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.1")));
                        }
                    });
            },
            submitPromotion(index) {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;

                if (this.arr_Member.length > index && this.arr_Member[index].PI > 0) {
                    this.arr_Member[index].bool_sendLoading = true;

                    this.obj_PI.R = [];
                    this.obj_PI.R.push({
                        "MI": this.arr_Member[index].MI,
                        "PI": this.arr_Member[index].PI
                    });

                    var that = this;

                    this.postDataApi(`/api/mpromo/mapv2`, this.obj_PI,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            that.arr_Member[index]['bool_sendLoading'] = false;
                            //that.bool_isNotifM = false;

                            if (s) {
                                if (d != null && d.D != null && d.D.Items != null && d.D.Items.length > 0 && !d.D.Items[0].S) {
                                    that.arr_Member[index]['str_PI_err'] = that.processMessage(d.D.Items[0].R);
                                    //this.$forceUpdate();
                                }
                                else {
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    that.arr_Member[index].PI = null;
                                    that.arr_Member[index]['str_PI_err'] = "";
                                }
                            }
                            else {
                                this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.1")));
                            }
                        });
                }
                else {
                    this.bool_fullLoading = false;
                }
            },
            processMessage(_errArr) {
                let temp = '';
                let msg = '';

                for (var i = 0; i < _errArr.length; i++) {
                    if (_errArr[i].ERRC && _errArr[i].CL && _errArr[i].CL.length > 0) {
                        var arr_args = this.splitColumn(_errArr[i].CL);
                        var targs = [];
                        targs.push(this.utilGetErrorLanguage(_errArr[i].ERRC));
                        for (var j = 0; j < arr_args.length; j++) {
                            targs.push(arr_args[j]);
                        }

                        temp = String.format.apply(null, targs);
                    }
                    else if (_errArr[i].ERRC) {
                        temp = this.utilGetErrorLanguage(_errArr[i].ERRC);
                    }
                    else if (_errArr[i].CL && _errArr[i].CL.length > 0) {
                        if (_errArr[i].CL.length == 1)
                            temp = this.utilGetErrorLanguage(_errArr[i].CL[0]);
                        else {
                            var arr_ags = this.splitColumnName(_errArr[i].CL);
                            temp = arr_ags.join("\n\n");
                        }
                    }

                    msg += temp + "\n\n";
                }

                return msg;
            },
            //handle {0} and "Err.number" case
            splitColumn(arr_cn) {
                for (var k = 0; k < arr_cn.length; k++) {
                    arr_cn[k] = arr_cn[k];
                }
                return arr_cn;
            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                };
            },

            toggleFingPrintId(data, aRow, bRow) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.UBI;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(aRow + '_' + bRow);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[aRow + '_' + bRow] = d.D.Items;
                                that.opened.push(aRow + '_' + bRow)
                            }
                        });
                }
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.MI;

                const index = that.opened.indexOf(data.I);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[data.I] = d.D.Items;
                                that.opened.push(data.I)
                            }
                        });
                }
                this.resizeTableHead()
            },

            AgentGroupChange(value) {
                var that = this;
                this.bool_currencyloaded = false;
                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                }

                this.getDataApi('/api/dd/cur/' + agi,
                    function (d, s) {
                        if (s) {
                            that.bool_currencyloaded = true;
                            that.dd_currency = d.dropdownlist;
                        }
                    });
                var agiSelectedValue = agi;
                var agentList = agiSelectedValue.split("-");
                var agiValue = agentList[agentList.length - 1];
                this.sensBtn = ((this.isSENS == 1 && agiValue != this.curAGI) ? true : false);
            },
            resizeTableHead() {
                setTimeout(() => {
                    $('#tBody table thead').show();
                    $('#tBody table tr:nth-child(2) td').css('width', "");
                    $('#tBody table tr th').each(function (key, v) {
                        var colNo = key + 1;
                        $('#tBody table tr:nth-child(2) td:nth-child(' + colNo + ')').css('width', (v.offsetWidth) + "px");
                        $('#tHead table tr th:nth-child(' + colNo + ')').css('width', (v.offsetWidth) + "px");
                    });
                    $('#tBody table thead').hide();
                    $("#tHead").scroll(function () {
                        $("#tBody").scrollLeft($("#tHead").scrollLeft());
                    });
                    $("#tBody").scroll(function () {
                        $("#tHead").scrollLeft($("#tBody").scrollLeft());
                    });
                }, 500)
            }
        },
        created() {
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.MP';
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
                this.AgentGroupChange("4-" + this.getUserInfo.AAGI);
            }
            else {
                this.getDropdownList();
            }
        }

    }
</script>
<style>
    .inline-promo350 {
        width: 450px !important;
        overflow: visible;
        text-overflow: ellipsis;
    }

    .table-wrapper .custom-table-wrapper.manual-promotion-body {
        overflow: unset !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/ManualPromotion.vue